import {
    GEO_AVAILABLE, GEO_UNAVAILABLE,
    GEO_ENABLED, GEO_DENIED,
    GEO_STORED, GEO_INIT, GEO_RESOLVED,
    GEO_INFORMED, GEO_RESET_INFORMED,
    GEO_WAITING, GEO_STOP_WATCHING } from './../actions/GeoLocationAction'

const defaultState = {
    available : null,
    enabled   : null,
    waiting   : false,
    stored    : false,
    watching  : false,
    watchingId: null,
    coords    : null,
    resolved  : false,
    informed  : false
};

const geo = (state = defaultState, action) =>
{
    let newState;
    switch (action.type)
    {
        case GEO_RESOLVED:
            newState = {...state,
                resolved: true
            };
            break;
        case GEO_AVAILABLE:
            newState = {...state,
                available: true
            };
            break;
        case GEO_UNAVAILABLE:
            newState = {...state,
                available : false,
                enabled   : false,
                watching  : false,
                waiting   : false,
                watchingId: null,
                resolved  : true
            };
            break;
        case GEO_ENABLED:
            newState = {...state,
                enabled: true
            };
            break;
        case GEO_DENIED:
            newState = {...state,
                enabled   : false,
                waiting   : false,
                watching  : false,
                watchingId: null,
                resolved  : true
            };
            break;
        case GEO_INIT:
            newState = {...state,
                watchingId: action.watchingId,
                watching  : true,
                available : true,
                enabled   : true
            };
            break;
        case GEO_WAITING:
            newState = {...state,
                waiting: true
            };
            break;
        case GEO_STOP_WATCHING:
            newState = {...state,
                watching  : false,
                watchingId: null,
                coords    : null,
                resolved  : true,
                stored    : false
            };
            break;
        case GEO_STORED:
            newState = {...state,
                available : true,
                enabled   : true,
                waiting   : false,
                watching  : true,
                coords    : action.coords,
                resolved  : true,
                stored    : true
            };
            break;
        case GEO_INFORMED:
            newState = {...state,
                informed: true
            };
            break;
        case GEO_RESET_INFORMED:
            newState = {...state,
                informed: false
            };
            break;
        default:
            newState = state;
            break
    }

    return newState;
};

export default geo;


// WEBPACK FOOTER //
// ./src/reducers/GeoLocationReducer.js